import { graphql } from "~/gql";

export const CREATE_AND_ADD_UPLIFT = graphql(/* GraphQL */ `
  mutation createAndAddUplift($matterId: Float!, $data: UpliftCreateInput!) {
    createAndAddUplift(matterId: $matterId, data: $data) {
      ...UpliftParts
    }
  }
`);
